import React, { useState, useEffect, useRef } from 'react';
import { Edit3, Save, Trash2, X, Printer, ArrowLeft } from 'lucide-react';
import apiService from '../config';

const KutumbForm = ({ ownerId, onBack }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(true);
  const documentRef = useRef(null);
  const [projectName, setProjectName] = useState('');
  const [projectId, setProjectId] = useState(null);
  const [proposalId, setProposalId] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [savingRowIndex, setSavingRowIndex] = useState(null);
  const [savingType, setSavingType] = useState(null); 
  const ROLES = {
    DRO: 22,
  };

  const [userRole, setUserRole] = useState(() => {
    try {
      const userData = localStorage.getItem("userData");
      if (userData) {
        const user = JSON.parse(userData);
        return user.user_role || user.usr_role || null;
      }
    } catch (error) {
      console.error("Error parsing user data:", error);
    }
    return null;
  });

  const isDRO = userRole === ROLES.DRO;


  // Fetch projectId similar to Section15
  useEffect(() => {
    const getProjectInfo = () => {
      const currentProjectData = localStorage.getItem('currentProjectData');
      if (currentProjectData) {
        try {
          const projectData = JSON.parse(currentProjectData);
          return {
            id: projectData.project_id || projectData.id,
            name: projectData.project_name || projectData.name
          };
        } catch (e) {
          console.error('Error parsing current project data:', e);
        }
      }

      const selectedProject = localStorage.getItem('selectedProject');
      if (selectedProject) {
        try {
          const project = JSON.parse(selectedProject);
          return {
            id: project.project_id || project.id,
            name: project.project_name || project.name
          };
        } catch (e) {
          console.error('Error parsing selected project:', e);
        }
      }

      const userData = localStorage.getItem('userData');
      if (userData) {
        try {
          const user = JSON.parse(userData);
          return {
            id: user.data?.project_id || user.project_id,
            name: user.data?.project_name || user.project_name || 'Unknown Project'
          };
        } catch (e) {
          console.error('Error parsing user data:', e);
        }
      }
      return { id: null, name: null };
    };

    const projectInfo = getProjectInfo();
    setProjectId(projectInfo.id);
    setProjectName(projectInfo.name || '');
    console.log('Current Project Info:', projectInfo);
  }, []);

  // Fetch proposalId
  useEffect(() => {
    const getProposalInfo = () => {
      const currentProposal = JSON.parse(localStorage.getItem('userData') || '{}');
      if (currentProposal) {
        try {
          return {
            proposalId:
              currentProposal?.data?.default_proposal ||
              currentProposal?.data?.proposalId ||
              currentProposal?.default_proposal ||
              currentProposal?.proposalId ||
              null,
          };
        } catch (e) {
          console.error('Error parsing proposal info:', e);
        }
      }
      return { proposalId: null };
    };

    const proposalInfo = getProposalInfo();
    setProposalId(proposalInfo.proposalId);
  }, []);


  const [formData, setFormData] = useState({
    village: 'ता. नावाचा',
    office: 'बाधित गावठाण मौजे. सावळी ता.संग्रामपूर जि. बुलडाणा येथील बाधित कुटुंबाचे सर्व्हेक्षण व गणना',
    year: '',
    surveyDate: '',
    section1_name: '',
    section1_address: '',
    section2_bank_name: '',
    section2_account_number: '',
    section3_text: '',
    section3_other: '',
    section4_text: '',
    section14_text: '',
    landDetails: [
      { sr: 1, name: '', age: '', relation: '', occupation: '', annualIncome: '', disabled: '', disabled_type: '', disabled_other: '',physically_disabled_type: '',
    physically_disabled_type_other: '',   birth_date: '', death_date: '', isDeath: 'नाही'
 },
    ],
    section6_has_land: '',
    section6_rows: [
      { village: '', gatNo: '', totalArea: '', acquiredArea: '', constructionArea: '', family_house_total_area:'', family_house_acquire_area:'' },
    ],
    section7_gotha_details: '',
    section7_has_livestock: '',
    section7_rows: [{
      property_type:'', property_name:'', property_count:'', product_from_property:'', remarks:'',
    }],
    section8_has_property: '',
    section8_rows: [{
      property_type:'', property_name:'', property_count:'', product_from_property:'', remarks:'', property_owner : '', property_owner_realtion :''
    }],
    section9_has_vulnerability: '',
    section9_text: '',
    section10_rows: [
      { rationCard: '', rationCardNo: '', ownerName: '', aadharCard: '', aadharCardNo: '' },
    ],
    section11_has_business: '',
    section11_rows: [],
    section12_details: '',
    section12_sign1: '',
    section12_sign2: '',
    section13_certificate_name: '',
    section13_relationship: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
      ...(name === 'section3_text' && value !== 'इतर' ? { section3_other: '' } : {}),
      ...(name === 'section14_text'),
      ...(name === 'section6_has_land' && value === 'नाही' ? { section6_rows: [{ village: '', gatNo: '', totalArea: '', acquiredArea: '', family_house_total_area:'', family_house_acquire_area:'' }] } : {}),
      ...(name === 'section7_has_livestock' && value === 'होय' && prev.section7_rows.length === 0 
          ? { section7_rows: [{ type: '', number: '', area: '', compensation: '', note: '', note_other: '', isSaved: false }] } 
          : {}),
      ...(name === 'section7_has_livestock' && value === 'नाही' ? { section7_rows: [{type: '', number: '', area: '', compensation: '', total: ''}] } : {}),
      ...(name === 'section8_has_property' && value === 'होय' && prev.section8_rows.length === 0 
          ? { section8_rows: [{ type: '', number: '', area: '', compensation: '', total: '' }] } 
          : {}),
      ...(name === 'section8_has_property' && value === 'नाही' ? { section8_rows: [] } : {}),
      ...(name === 'section9_has_vulnerability' && value === 'नाही' ? { section9_text: '' } : {}),
      ...(name === 'section11_has_business' && value === 'होय' && prev.section11_rows.length === 0 
          ? { section11_rows: [{ name: '', commercial_code: '', compensation: '', total: '' }] } 
          : {}),
      ...(name === 'section11_has_business' && value === 'नाही' ? { section11_rows: [] } : {}),
    }));
  };

  const handleTableChange = (section, index, field, value) => {
    setFormData(prev => ({
      ...prev,
      [section]: prev[section].map((row, i) => 
        i === index 
          ? { 
              ...row, 
              [field]: value,
              ...(field === 'disabled' && value === 'नाही' ? { disabled_type: '', disabled_other: '' } : {}),
              ...(field === 'disabled_type' && value !== 'इतर' ? { disabled_other: '' } : {}),
              ...(field === 'compensation' && value === 'नाही' ? { note_other: '' } : {}),
              ...(field === 'isDeath' && value === 'नाही'? { death_date: '' }: {})
            } 
          : row
      ),
    }));
  };

  const addTableRow = (section, defaultRow) => {
    setFormData(prev => ({
      ...prev,
      [section]: [...prev[section], { ...defaultRow, sr: section === 'landDetails' ? prev[section].length + 1 : undefined }],
    }));
  };

  const removeTableRow = (section, index) => {
    setFormData(prev => ({
      ...prev,
      [section]: prev[section].filter((_, i) => i !== index).map((row, i) => 
        section === 'landDetails' ? { ...row, sr: i + 1 } : row
      ),
    }));
  };

  const handleRowSave = (index) => {
    setFormData(prev => ({
      ...prev,
      section7_rows: prev.section7_rows.map((row, i) => 
        i === index ? { ...row, isSaved: true } : row
      ),
    }));
    alert(`✅ Row ${index + 1} saved successfully!`);
  };

  // ✅ Save new family member (POST)
// const handleAddFamilyMember = async (member, index) => {
//   setSavingRowIndex(index);
//   setSavingType("add");
//   try {
//     const familyData = {
//       project_id: projectId,
//       proposal_id: proposalId,
//       owner_id: ownerId,
//       name: member.name,
//       age: member.age,
//       relation_to_head: member.relation,
//       income_source: member.occupation,
//       annual_income: member.annualIncome,
//       physically_disabled: member.disabled === 'होय' ? 1 : 0,
//       physically_disabled_type: member.disabled_type || member.physically_disabled_type || null,
//       physically_disabled_type_other: member.disabled_other || member.physically_disabled_type_other || null,
//     };

//     const response = await apiService.postAddFamilyDetails(familyData);
//     // After successful PATCH (update existing family member)
// if (response.status === 200) {
//   alert('✅ Family member updated successfully!');

//   try {
//     const freshResponse = await apiService.getFamilyDetailsByOwner(ownerId);

//     if (freshResponse.status === 200) {
//       const { familyDetails } = freshResponse.data;

//       setFormData(prev => {
//         const updatedLandDetails = familyDetails.map((member, index) => ({
//           sr: index + 1,
//           family_id: member.family_id || member.id || null,
//           name: member.name || '',
//           age: member.age ? String(member.age) : '',
//           relation: member.relation_to_head || '',
//           occupation: member.income_source || '',
//           annualIncome: member.annual_income ? String(member.annual_income) : '',
//           disabled: member.physically_disabled ? 'होय' : 'नाही',
//           physically_disabled_type: member.physically_disabled_type || '',
//           physically_disabled_type_other: member.physically_disabled_type_other || '',
//           isNew: false,
//         }));

//         return {
//           ...prev,
//           landDetails: updatedLandDetails,
//         };
//       });
//     }
//   } catch (refreshErr) {
//     console.error('Failed to refresh family list after update:', refreshErr);
//   }
// } else {
//       alert('⚠️ Failed to add family member.');
//     }
//   } catch (err) {
//     console.error('❌ Add Family Member Error:', err);
//     alert('Error adding family member.');
//   }finally {
//     setSavingRowIndex(null);
//     setSavingType(null);
//   }
// };

const handleAddFamilyMember = async (member, index) => {
  setSavingRowIndex(index);
  setSavingType("add");

  try {
    const familyData = {
      project_id: projectId,
      proposal_id: proposalId,
      owner_id: ownerId,
      name: member.name,
      age: member.age,
      relation_to_head: member.relation,
      income_source: member.occupation,
      annual_income: member.annualIncome,
      physically_disabled: member.disabled === 'होय' ? 1 : 0,
      physically_disabled_type: member.disabled_type || member.physically_disabled_type || null,
      physically_disabled_type_other: member.disabled_other || member.physically_disabled_type_other || null,
      birth_date: member.birth_date ,  
      death_date: member.death_date || '',
      isDeath: member.isDeath === 'होय' ? 1 : 0,
    };

    const response = await apiService.postAddFamilyDetails(familyData);

    if (response.status === 200) {
      alert('✅ Family member added successfully!');

      try {
        const freshResponse = await apiService.getFamilyDetailsByOwner(ownerId);

        if (freshResponse.status === 200) {
          const { ownerDetail, familyDetails } = freshResponse.data;

          setFormData(prev => {
            const updatedLandDetails = familyDetails.map((m, idx) => ({
              sr: idx + 1,
              family_id: m.family_id || m.id || null,
              name: m.name || '',
              age: m.age ? String(m.age) : '',
              relation: m.relation_to_head || '',
              occupation: m.income_source || '',
              annualIncome: m.annual_income ? String(m.annual_income) : '',
              disabled: m.physically_disabled ? 'होय' : 'नाही',
              physically_disabled_type: m.physically_disabled_type || '',
              physically_disabled_type_other: m.physically_disabled_type_other || '',
              birth_date: m.birth_date || '',
              death_date: m.death_date || '',
              isDeath:m.isDeath ? 'होय' : 'नाही',
              isNew: false,
            }));

            const updatedSection10Rows = familyDetails.map((m) => ({
              family_id: m.family_id || m.id || null,
              rationCard: ownerDetail.owner_name || '',
              rationCardNo: ownerDetail.family_ration_card_no || '',
              ownerName: m.name || '',
              aadharCard: m.adharcard_no || '',
              aadharCardNo: m.adharcard_no || '',
              isNew: false,
            }));

            const updatedSection11Rows = familyDetails.map((m) => ({
              family_id: m.family_id || m.id || null,
              name: m.name || '',
              commercial_code: m.professional_skills || '',
              compensation: m.professional_skills_income
                ? String(m.professional_skills_income)
                : '',
              total: m.remarks || '',
              isNew: false,
            }));

            return {
              ...prev,
              landDetails: updatedLandDetails,
              section10_rows: updatedSection10Rows,
              section11_has_business: familyDetails.some(m => m.name) ? 'होय' : 'नाही',
              section11_rows: updatedSection11Rows,
            };
          });
        }
      } catch (refreshErr) {
        console.error('Failed to refresh family list after add:', refreshErr);
      }
    } else {
      alert('⚠️ Failed to add family member.');
    }
  } catch (err) {
    console.error('❌ Add Family Member Error:', err);
    alert('Error adding family member.');
  } finally {
    setSavingRowIndex(null);
    setSavingType(null);
  }
};

// ✅ Update existing family member (PATCH)
const handleUpdateFamilyMember = async (familyId, member, index) => {
  setSavingRowIndex(index);
  setSavingType("update");
  try {
    const familyData = {
      project_id: projectId,
      proposal_id: proposalId,
      owner_id: ownerId,
      name: member.name,
      age: member.age,
      relation_to_head: member.relation,
      income_source: member.occupation,
      annual_income: member.annualIncome,
      physically_disabled: member.disabled === 'होय' ? 1 : 0,
      physically_disabled_type: member.disabled_type || member.physically_disabled_type || null,
      physically_disabled_type_other: member.disabled_other || member.physically_disabled_type_other || null,
      birth_date: member.birth_date,
      death_date: member.death_date || '',
      isDeath:member.isDeath === 'होय' ? 1 : 0,
    };

    const response = await apiService.patchUpdateFamilyDetails(familyId, familyData);
    if (response.status === 200) {
      alert('✅ Family member updated successfully!');
      // fetchFamilyDetails(); 
    } else {
      alert('⚠️ Failed to update family member.');
    }
  } catch (err) {
    console.error('❌ Update Family Member Error:', err);
    alert('Error updating family member.');
  }finally {
    setSavingRowIndex(null);
    setSavingType(null);
  }
};

//Delete Family Member
const handleDeleteFamilyMember = async (familyId, index) => {
  if (!familyId) {
    // Local-only row
    const targetSr = formData.landDetails[index]?.sr;
    setFormData(prev => ({
      ...prev,
      landDetails:    prev.landDetails   .filter(r => r.sr !== targetSr),
      section10_rows: prev.section10_rows.filter(r => r.sr !== targetSr), // if you store sr
      section11_rows: prev.section11_rows.filter(r => r.sr !== targetSr),
    }));
    return;
  }

  if (!window.confirm("Delete this family member and all related Section 10 & 11 entries?")) return;

  try {
    const res = await apiService.deleteFamilyDetails(familyId);
    if (res.status !== 200 && res.status !== 204) throw new Error("Delete failed");

    // Remove by family_id (most reliable)
    setFormData(prev => ({
      ...prev,
      landDetails:    prev.landDetails   .filter(r => r.family_id !== familyId)
                                        .map((r, i) => ({ ...r, sr: i + 1 })),
      section10_rows: prev.section10_rows.filter(r => r.family_id !== familyId),
      section11_rows: prev.section11_rows.filter(r => r.family_id !== familyId),
    }));

    alert("Deleted successfully");

    // Best: refresh everything
    // await fetchFamilyDetails();

  } catch (err) {
    console.error(err);
    alert("Delete failed");
  }
};

// Add / replace with this handler
const handleDeleteAnimalProperty = async (propertyId, index) => {
  // New row (not saved yet) → just remove from UI
  if (!propertyId) {
    removeTableRow('section7_rows', index);
    return;
  }

  if (!window.confirm("Are you sure you want to delete this livestock record?")) {
    return;
  }

  try {
    const response = await apiService.deleteFamilyProperty(propertyId);

    if (response.status === 200 || response.status === 204) {
      alert("Livestock record deleted successfully");

      setFormData(prev => ({
        ...prev,
        section7_rows: prev.section7_rows.filter((_, i) => i !== index)
      }));

      // Optional (recommended if other users might edit):
      // await fetchFamilyDetails();
    } else {
      alert("Failed to delete livestock record (server responded with status " + response.status + ")");
    }
  } catch (err) {
    console.error("Delete livestock failed:", err);
    alert("Error while deleting livestock record");
  }
};

const handleDeleteFamilyProperty = async (propertyId, index) => {
  // New / unsaved row → just remove locally
  if (!propertyId) {
    removeTableRow('section8_rows', index);
    return;
  }

  if (!window.confirm("Are you sure you want to delete this property record?")) {
    return;
  }

  try {
    const response = await apiService.deleteFamilyProperty(propertyId);

    if (response.status === 200 || response.status === 204) {
      alert("Property record deleted successfully");

      setFormData(prev => ({
        ...prev,
        section8_rows: prev.section8_rows.filter((_, i) => i !== index)
      }));

      // Optional – refresh full data if you want to be extra safe:
      // await fetchFamilyDetails();
    } else {
      alert(`Delete failed (status: ${response.status})`);
    }
  } catch (err) {
    console.error("❌ Delete property failed:", err);
    alert("Error while deleting property record");
  }
};


// ✅ Save (POST)
const handleAddSection10Member = async (member, index) => {
  setSavingRowIndex(index);
  setSavingType("add");
  try {
    const familyData = {
      project_id:projectId,
      proposal_id:proposalId,
      name: member.ownerName,
      adharcard_no: member.aadharCard,
      owner_id: ownerId,
    };

    const response = await apiService.postAddFamilyDetails(familyData);

    if (response.status === 200) {
      alert('✅ Member added successfully!');
      setFormData(prev => {
        const updated = [...prev.section10_rows];
        updated[index] = {
          ...updated[index],
          family_id: response.data.family_id || response.data.id,
          isNew: false,
        };
        return { ...prev, section10_rows: updated };
      });
    } else {
      alert('⚠️ Failed to add member.');
    }
  } catch (err) {
    console.error('❌ Add Section 10 Member Error:', err);
    alert('Error adding member.');
  }finally {
    setSavingRowIndex(null);
    setSavingType(null);
  }
};

// ✅ Update (PATCH)
const handleUpdateSection10Member = async (familyId, member, index) => {
  setSavingRowIndex(index);
  setSavingType("update");
  if (!familyId) {
    alert('❌ Missing familyId for update');
    return;
  }

  try {
    const familyData = {
      name: member.ownerName,
      adharcard_no: member.aadharCard,
    };

    const response = await apiService.patchUpdateFamilyDetails(familyId, familyData);

    if (response.status === 200) {
      alert('✅ Member updated successfully!');
    } else {
      alert('⚠️ Failed to update member.');
    }
  } catch (err) {
    console.error('❌ Update Section 10 Member Error:', err);
    alert('Error updating member.');
  }finally {
    setSavingRowIndex(null);
    setSavingType(null);
  }
};

// ✅ POST - Add new Section 11 member
const handleAddSection11Member = async (member, index) => {
  setSavingRowIndex(index);
  setSavingType("add");
  try {
    const familyData = {
      project_id: projectId,
      proposal_id: proposalId,
      owner_id: ownerId,
      name: member.name,
      age: 0,
      relation_to_head: '',
      income_source: '',
      annual_income: 0,
      physically_disabled: 0,
      professional_skills: member.commercial_code,
      professional_skills_income: member.compensation || 0,
      adharcard_no: '',
      document: '',
      remarks:member.remarks,
      isDeath: 0,
    };

    const response = await apiService.postAddFamilyDetails(familyData);

    if (response.status === 200) {
      alert('✅ Member added successfully!');
      setFormData(prev => {
        const updated = [...prev.section11_rows];
        updated[index] = {
          ...updated[index],
          family_id: response.data.family_id || response.data.id,
          isNew: false, // switch to Update mode
        };
        return { ...prev, section11_rows: updated };
      });
    } else {
      alert('⚠️ Failed to add member.');
    }
  } catch (error) {
    console.error('❌ Add Section 11 Member Error:', error);
    alert('Error adding Section 11 member.');
  }finally {
    setSavingRowIndex(null);
    setSavingType(null);
  }
};

// ✅ PATCH - Update existing Section 11 member
const handleUpdateSection11Member = async (familyId, member, index) => {
  setSavingRowIndex(index);
  setSavingType("update");
  if (!familyId) {
    alert('❌ Missing familyId for update');
    return;
  }

  try {
    const familyData = {
      name: member.name,
      professional_skills: member.commercial_code,
      professional_skills_income: member.compensation || 0,
      remarks: member.total,
    };

    const response = await apiService.patchUpdateFamilyDetails(familyId, familyData);

    if (response.status === 200) {
      alert('✅ Member updated successfully!');
    } else {
      alert('⚠️ Failed to update member.');
    }
  } catch (error) {
    console.error('❌ Update Section 11 Member Error:', error);
    alert('Error updating Section 11 member.');
  }finally {
    setSavingRowIndex(null);
    setSavingType(null);
  }
};

// const handleAddFamilyProperty = async (property, index) => {
//   setSavingRowIndex(index);
//   setSavingType("add");
//   try {
//     const propertyData = {
//       family_id: property.family_id || formData?.ownerDetails?.family_id,
//       owner_id: ownerId,
//       property_type: "Other",
//       property_name: property.property_name,
//       property_count: property.property_count,
//       product_from_property: property.product_from_property,
//       has_cowshed: property.has_cowshed ,
//       remarks: property.remarks,
//     };

//     const res = await apiService.postAddFamilyProperty(propertyData);
//     if (res.status === 200) {
//       alert('✅ Property added successfully!');
//       fetchFamilyDetails();
//       setFormData(prev => {
//         const rows = [...prev.section8_rows];
//         rows[index] = {
//           ...rows[index],
//           // property_id: res.data.property_id || res.data.id,
//           isNew: false,
//         };
//         return { ...prev, section8_rows: rows };
//       });
//     } else alert('⚠️ Failed to add property.');
//   } catch (err) {
//     console.error('❌ Add Property Error:', err);
//   }finally {
//     setSavingRowIndex(null);
//     setSavingType(null);
//   }
// };

const handleAddFamilyProperty = async (property, index) => {
  setSavingRowIndex(index);
  setSavingType("add");

  try {
    const propertyData = {
      family_id: property.family_id || formData?.ownerDetails?.family_id,
      owner_id: ownerId,
      property_type: "Other",
      property_name: property.property_name,
      property_count: property.property_count,
      product_from_property: property.product_from_property,
      has_cowshed: property.has_cowshed,
      remarks: property.remarks,
      property_owner:property.property_owner,
      property_owner_realtion:property.property_owner_realtion
    };

    const res = await apiService.postAddFamilyProperty(propertyData);

    if (res.status === 200) {
      alert('✅ Property added successfully!');

      // ────────────────────────────────────────────────
      //   Refresh only the "other properties" list
      // ────────────────────────────────────────────────
      try {
        const fresh = await apiService.getFamilyDetailsByOwner(ownerId);

        if (fresh.status === 200) {
          const { othersProperty } = fresh.data;

          setFormData(prev => {
            const updatedRows = othersProperty.map((item, idx) => ({
              property_id: item.property_id || item.family_property_id || item.id || null,
              family_id: item.family_id || prev.ownerDetails?.family_id || null,
              property_type: item.property_type || '',
              property_name: item.property_name || '',
              property_count: item.property_count ? String(item.property_count) : '',
              product_from_property: item.product_from_property || '',
              property_owner:item.property_owner || '',
              property_owner_realtion: item.property_owner_realtion || '',
              has_cowshed: item.has_cowshed || '',
              remarks: item.remarks || '',
              document: item.document || '',
              isNew: false,
            }));

            return {
              ...prev,                           // ← protects sections 1–7, 9–14, etc.
              section8_rows:
                updatedRows.length > 0
                  ? updatedRows
                  : [
                      {
                        property_type: '',
                        property_name: '',
                        property_count: '',
                        product_from_property: '',
                        property_owner:'',
                        property_owner_realtion:'',
                        has_cowshed: '',
                        remarks: '',
                        document: '',
                        isNew: true,
                      },
                    ],
            };
          });
        }
      } catch (refreshErr) {
        console.warn('Could not refresh other properties after save', refreshErr);

        // Fallback: at least mark current row as saved
        setFormData(prev => {
          const rows = [...prev.section8_rows];
          rows[index] = { ...rows[index], isNew: false };
          return { ...prev, section8_rows: rows };
        });
      }
    } else {
      alert('⚠️ Failed to add property.');
    }
  } catch (err) {
    console.error('❌ Add Property Error:', err);
    alert('Error adding property.');
  } finally {
    setSavingRowIndex(null);
    setSavingType(null);
  }
};

const handleUpdateFamilyProperty = async (propertyId, property, index) => {
  setSavingRowIndex(index);
  setSavingType("update");
  if (!propertyId) {
    alert('❌ Missing propertyId for update');
    return;
  }
  try {
    const propertyData = {
      family_id: property.family_id || formData?.ownerDetails?.family_id,
      owner_id: ownerId,
      property_type: "Other",
      property_name: property.property_name,
      property_count: property.property_count,
      product_from_property: property.product_from_property,
      has_cowshed: property.has_cowshed ,
      remarks: property.remarks,
      property_owner:property.property_owner,
      property_owner_realtion:property.property_owner_realtion
    };

    const res = await apiService.patchUpdateFamilyProperty(propertyId, propertyData);
    if (res.status === 200) alert('✅ Property updated successfully!');
    else alert('⚠️ Failed to update property.');
  } catch (err) {
    console.error('❌ Update Property Error:', err);
  }finally {
    setSavingRowIndex(null);
    setSavingType(null);
  }
};

// ✅ Use Section 8 API for Section 7 (Livestock)
// const handleAddAnimalProperty = async (animal, index) => {
//   setSavingRowIndex(index);
//   setSavingType("add");
//   try {
//     const propertyData = {
//       family_id: animal.family_id || formData?.ownerDetails?.family_id,
//       owner_id: ownerId,
//       property_type: "Animal",
//       property_name: animal.property_name,
//       property_count: animal.property_count,
//       product_from_property: animal.product_from_property,
//       has_cowshed: animal.compensation,
//       remarks: animal.remarks || animal.note_other || '',
//     };

//     const res = await apiService.postAddFamilyProperty(propertyData);
//     if (res.status === 200) {
//       alert('✅ Livestock added successfully!');
//       fetchFamilyDetails();
//       setFormData(prev => {
//         const rows = [...prev.section7_rows];
//         rows[index] = { ...rows[index], isNew: false };
//         return { ...prev, section7_rows: rows };
//       });
//     } else {
//       alert('⚠️ Failed to add livestock.');
//     }
//   } catch (err) {
//     console.error('❌ Add Livestock Error:', err);
//   }finally {
//     setSavingRowIndex(null);
//     setSavingType(null);
//   }
// };

const handleAddAnimalProperty = async (animal, index) => {
  setSavingRowIndex(index);
  setSavingType("add");

  try {
    const propertyData = {
      family_id: animal.family_id || formData?.ownerDetails?.family_id,
      owner_id: ownerId,
      property_type: "Animal",
      property_name: animal.property_name,
      property_count: animal.property_count,
      product_from_property: animal.product_from_property,
      has_cowshed: animal.compensation,           // ← note: this field name looks suspicious
      remarks: animal.remarks || animal.note_other || '',
    };

    const res = await apiService.postAddFamilyProperty(propertyData);

    if (res.status === 200) {
      alert('✅ Livestock added successfully!');

      // ────────────────────────────────────────────────
      //   Fetch fresh list of animals only (recommended)
      // ────────────────────────────────────────────────
      try {
        const fresh = await apiService.getFamilyDetailsByOwner(ownerId);

        if (fresh.status === 200) {
          const { animals } = fresh.data;

          setFormData(prev => {
            const updatedRows = animals.map((item, idx) => ({
              property_id: item.property_id || item.family_property_id || item.id || null,
              family_id: item.family_id || prev.ownerDetails?.family_id || null,
              property_type: item.property_type || 'Animal',
              property_name: item.property_name || '',
              property_count: item.property_count ? String(item.property_count) : '',
              product_from_property: item.product_from_property || '',
              has_cowshed: item.has_cowshed || '',
              remarks: item.remarks || '',
              document: item.document || '',
              isNew: false,
            }));

            return {
              ...prev,                    // ← keeps all other sections safe
              section7_rows: updatedRows.length > 0 ? updatedRows : [{
                property_type: '',
                property_name: '',
                property_count: '',
                product_from_property: '',
                has_cowshed: '',
                remarks: '',
                document: '',
                isNew: true,
              }],
            };
          });
        }
      } catch (refreshErr) {
        console.warn('Could not refresh animals list after save', refreshErr);
        // Still mark as saved locally (optimistic)
        setFormData(prev => {
          const rows = [...prev.section7_rows];
          rows[index] = { ...rows[index], isNew: false };
          return { ...prev, section7_rows: rows };
        });
      }
    } else {
      alert('⚠️ Failed to add livestock.');
    }
  } catch (err) {
    console.error('❌ Add Livestock Error:', err);
    alert('Error adding livestock.');
  } finally {
    setSavingRowIndex(null);
    setSavingType(null);
  }
};

const handleUpdateAnimalProperty = async (propertyId, animal, index) => {
  setSavingRowIndex(index);
  setSavingType("update");
  if (!propertyId) {
    alert('❌ Missing propertyId for update');
    return;
  }

  try {
    const propertyData = {
      family_id: animal.family_id || formData?.ownerDetails?.family_id,
      owner_id: ownerId,
      property_type: "Animal",
      property_name: animal.property_name,
      property_count: animal.property_count,
      product_from_property: animal.product_from_property,
      has_cowshed: animal.compensation,
      remarks: animal.remarks || animal.note_other || '',
    };

    const res = await apiService.patchUpdateFamilyProperty(propertyId, propertyData);
    if (res.status === 200) alert('✅ Livestock updated successfully!');
    else alert('⚠️ Failed to update livestock.');
  } catch (err) {
    console.error('❌ Update Livestock Error:', err);
  }finally {
    setSavingRowIndex(null);
    setSavingType(null);
  }
};


  const handleSave = async () => {
    setIsSaving(true);
  try {
    const updateData = {
      owner_name:formData.section1_name || '',
      owner_address: formData.section1_address || '',
      bank_name: formData.section2_bank_name || '',
      account_number: formData.section2_account_number || '',
      family_type_of_house: formData.section3_text || '',
      // family_house_area: formData.section4_text || '',
      family_type_of_house_other: formData.section3_other || '',
      Family_11_1_classification : formData.section14_text || '',
      family_ration_card_no: formData.section10_rows?.[0]?.rationCardNo || '',
      family_certificate_date: formData.surveyDate || '',
      family_project_affected_relation: formData.section13_relationship || '',
      family_project_affected_certificate_person_name: formData.section13_certificate_name || '',
      family_rehabilitation_opinion: formData.section12_details || '',
      family_socially_weaker: formData.section9_has_vulnerability === 'होय' 
        ? formData.section9_text || 'होय'
        : 'नाही',
      family_is_barn: formData.section7_gotha_details || '',

      // ✅ Section 6 fields
      village_name : formData.section6_rows?.[0]?.village || '',
      family_house_gat_no : formData.section6_rows?.[0]?.gatNo || '',
      owner_total_area : formData.section6_rows?.[0]?.totalArea || '',
      owner_aqr_area : formData.section6_rows?.[0]?.acquiredArea || '',
      owner_construction_area :formData.section6_rows?.[0]?.constructionArea || '',
      family_house_total_area : formData.section6_rows?.[0]?.familytotalarea || '',
      family_house_acquire_area : formData.section6_rows?.[0]?.familyacquirearea || '',

    };

    console.log('🔹 Sending update data:', updateData);

    const response = await apiService.patchUpdateMeasurement(ownerId, updateData);

    if (response.status === 200) {
      alert('✅ Details updated successfully!');
      setIsEditing(false);
    } else {
      alert('⚠️ Failed to update details. Please try again.');
    }
  } catch (error) {
    console.error('❌ Error updating measurement:', error);
    alert('Error while saving details. Please check console for more info.');
  }finally {
    setIsSaving(false); 
  }
};


  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const handlePrint = () => {
    const printContent = documentRef.current?.innerHTML;
    if (!printContent) {
      alert("No content available to print.");
      return;
    }

    const win = window.open("", "", "height=900,width=1200");
    win.document.write(`
      <html>
        <head>
          <title>विशेष प्रकल्प</title>
          <style>
            @page {
              size: A4 portrait;   
              margin-top: 0.19in;
              margin-bottom: 0.25in;
              margin-left: 0.81in;
              margin-right: 0.5in;
            }
            body {
              font-family: 'DVOT-Surekh', 'Mangal', 'Arial', sans-serif;
              font-size: 12px;
              line-height: 1.4;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin: 10px 0;
            }
            table, th, td {
              border: 1px solid black;
            }
            th, td {
              padding: 4px 6px;
              text-align: left;
            }
            .header {
              text-align: center;
              font-weight: bold;
              margin-bottom: 15px;
            }
            .section-title {
              font-weight: bold;
              margin: 10px 0 5px 0;
            }
            .home {
              text-align: right;
              font-weight: bold;
            }
            .no-border {
              border: none;
            }
            .vertical-line {
              border-right: 1px solid black;
            }
            .signature-section {
              display: flex;
              justify-content: space-between; 
              margin-top: 40px;
              padding: 0 40px;
            }
            .signature-box {
              text-align: center;
              flex: 1;
              font-weight: bold;
            }
            .date {
              margin-top: 20px;
              font-weight: bold;
            }
            .content {
              border-bottom: 1px solid black;
              padding-bottom: 4px;
            }
          </style>
        </head>
        <body>
          ${printContent}
        </body>
      </html>
    `);

    win.document.close();
    win.print();
  };

   useEffect(() => {
    if (ownerId) {
      fetchFamilyDetails();
    }
  }, [ownerId]);

   const fetchFamilyDetails = async () => {
    setLoading(true);
    try {
      const response = await apiService.getFamilyDetailsByOwner(ownerId);
      if (response.status === 200) {
        const { ownerDetail, familyDetails, animals, othersProperty } = response.data;

        setFormData(prev => ({
          ...prev,
          office:`बाधित गावठाण मौजे. ${ownerDetail.village_name} ता.${ownerDetail.taluka_name} जि.${ownerDetail.dist_name} येथील बाधित कुटुंबाचे सर्व्हेक्षण व गणना`,
          year:ownerDetail.survey_no || '',
          section1_name: ownerDetail.owner_name || '',
          section1_address: ownerDetail.owner_address || `${ownerDetail.village_name}, ता. ${ownerDetail.taluka_name}, जि. ${ownerDetail.dist_name}`,
          section2_bank_name: ownerDetail.bank_name || '',
          section2_account_number: ownerDetail.account_number || '',
          section3_text: ownerDetail.family_type_of_house || '',
          section3_other:ownerDetail.family_type_of_house_other || '',
          section4_text: ownerDetail.family_house_area || '',
          section14_text: ownerDetail.Family_11_1_classification || '',
          section9_has_vulnerability: ownerDetail.family_socially_weaker ? 'होय' : 'नाही',
          section9_text: ownerDetail.family_socially_weaker || '',
          section10_rows: familyDetails.map((member) => ({
          family_id: member.family_id || member.id || null,
          rationCard: ownerDetail.owner_name || '',
          rationCardNo: ownerDetail.family_ration_card_no || '',
          ownerName: member.name || '',
          aadharCard: member.adharcard_no || '',
          aadharCardNo: member.adharcard_no || '',
          isNew: false,
        })),

          section11_has_business: familyDetails.some(member => member.name) ? 'होय' : 'नाही',
          section11_rows: familyDetails
          // .filter(member => member.professional_skills)
          .map((member, index) => ({
            family_id: member.family_id || member.id || null, // ✅ keep ID
            name: member.name || '',
            commercial_code: member.professional_skills || '',
            compensation: member.professional_skills_income ? String(member.professional_skills_income) : '',
            total: member.remarks || '',
            isNew: false, // ✅ mark existing rows
          })),

          section12_details: ownerDetail.family_rehabilitation_opinion || '',
          section13_certificate_name: ownerDetail.family_project_affected_certificate_person_name || '',
          section13_relationship: ownerDetail.family_project_affected_relation || '',
          // surveyDate: ownerDetail.family_certificate_date || '',
          surveyDate: ownerDetail.family_certificate_date
          ? new Date(ownerDetail.family_certificate_date).toISOString().split('T')[0]
          : '',
          landDetails: familyDetails.map((member, index) => ({
          sr: index + 1,
          family_id: member.family_id || member.id,
          name: member.name || '',
          age: member.age ? String(member.age) : '',
          relation: member.relation_to_head || '',
          occupation: member.income_source || '',
          annualIncome: member.annual_income ? String(member.annual_income) : '',
          disabled: member.physically_disabled ? 'होय' : 'नाही',
          physically_disabled_type: member.physically_disabled_type || '',
          physically_disabled_type_other: member.physically_disabled_type_other || '',
          birth_date: member.birth_date ? new Date(member.birth_date).toISOString().split('T')[0] : '',
          death_date: member.death_date ? new Date(member.death_date).toISOString().split('T')[0] : '',
          isDeath:member.isDeath ? 'होय' : 'नाही',
          isNew: false, // ✅ Mark fetched rows as existing
        })),


          section6_has_land: ownerDetail.survey_no ? 'होय' : 'नाही',
          section6_rows: ownerDetail.survey_no
            ? [
                {
                  village: ownerDetail.village_name || '',
                  gatNo: ownerDetail.family_house_gat_no || '',
                  totalArea: ownerDetail.owner_total_area || '',
                  acquiredArea: ownerDetail.owner_aqr_area || '',
                  constructionArea: ownerDetail.owner_construction_area || '',
                  familytotalarea: ownerDetail.family_house_total_area || '',
                  familyacquirearea : ownerDetail.family_house_acquire_area || '',
                },
              ]
            : [{ village: '', gatNo: '', totalArea: '', acquiredArea: '', familytotalarea:'', familyacquirearea:'' }],
          section7_has_livestock: animals.length > 0 ? 'होय' : 'नाही',
          section7_has_shed:
    ownerDetail.family_is_barn && ownerDetail.family_is_barn.trim() !== ""
      ? "होय"
      : "नाही",
          section7_gotha_details: ownerDetail.family_is_barn || '',
          section7_rows:
            animals.length > 0
              ? animals.map((animal, i) => ({
                  property_id: animal.property_id || animal.family_property_id || animal.id || null,
                  family_id: animal.family_id || formData?.ownerDetails?.family_id || null,
                  property_type: animal.property_type || 'Livestock',
                  property_name: animal.property_name || '',
                  property_count: animal.property_count ? String(animal.property_count) : '',
                  product_from_property: animal.product_from_property || '',
                  has_cowshed: animal.has_cowshed || '',
                  remarks: animal.remarks || '',
                  document: animal.document || '',
                  isNew: false, // ✅ existing only
                }))
              : [
                  {
                    property_type: '',
                    property_name: '',
                    property_count: '',
                    product_from_property: '',
                    has_cowshed: '',
                    remarks: '',
                    document: '',
                    isNew: true, // ✅ brand new first row
                  },
                ],
          section8_has_property: othersProperty.length > 0 ? 'होय' : 'नाही',
          section8_rows:
            othersProperty.length > 0
              ? othersProperty.map((item, i) => ({
                  property_id: item.property_id || item.family_property_id || item.id || null,
                  family_id: item.family_id || formData?.ownerDetails?.family_id || null,
                  property_type: item.property_type || '',
                  property_name: item.property_name || '',
                  property_count: item.property_count || '',
                  product_from_property: item.product_from_property || '',
                  property_owner: item.property_owner || '',
                  property_owner_realtion:item.property_owner_realtion || '',
                  has_cowshed: item.has_cowshed,
                  remarks: item.remarks || '',
                  document: item.document || '',
                  isNew: false, // ✅ existing only
                }))
              : [
                  {
                    property_type: '',
                    property_name: '',
                    property_count: '',
                    product_from_property: '',
                    property_owner:'',
                    property_owner_realtion:'',
                    has_cowshed: '',
                    remarks: '',
                    document: '',
                    isNew: true, // ✅ brand new first row
                  },
                ],


        }));

      } else {
        alert('Failed to fetch family details.');
      }
    } catch (error) {
      console.error('Error fetching family details:', error);
      alert('Error fetching family details. Please try again.');
    }finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="p-8 min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading family details...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto p-6">

    <div className="flex justify-between items-center mb-6">
      <div className="flex gap-4">
        <button
          onClick={() => setIsEditing(!isEditing)}
          className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          {isEditing ? <X size={20} /> : <Edit3 size={20} />}
          {isEditing ? 'Cancel Edit' : 'Edit'}
        </button>
        <button
          onClick={handlePrint}
          className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
        >
          <Printer size={20} />
          Print
        </button>
      </div>

      <div>
        <button
          onClick={onBack}
          className="flex items-center gap-1 bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-2 rounded-md"
        >
          <ArrowLeft size={18} />
          Back
        </button>
      </div>
    </div>

      {/* Edit Modal */}
      {isEditing && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-y-auto">
          <div className="bg-white rounded-lg shadow-xl max-w-6xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold text-gray-800">Edit Form</h2>
                <button
                  onClick={() => setIsEditing(false)}
                  className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
                >
                  ×
                </button>
              </div>

              <div className="space-y-6">
                {/* Basic Info */}
                {/* <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block font-semibold text-gray-700 mb-2">कार्यालय तपशील</label>
                    <textarea
                      name="office"
                      value={formData.office}
                      onChange={handleInputChange}
                      rows="2"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md"
                    />
                  </div>
                  <div>
                    <label className="block font-semibold text-gray-700 mb-2">घर क्रमांक</label>
                    <input
                      type="text"
                      name="year"
                      value={formData.year}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md"
                    />
                  </div>
                </div> */}

                  <fieldset disabled={userRole === ROLES.DRO}> 
                {/* Section 1 */}
                <div>
                  <h3 className="font-bold text-lg mb-2">१. कुटुंब प्रमुखाचे नाव व पत्ता</h3>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block font-semibold text-gray-700 mb-2">कुटुंब प्रमुखाचे नाव</label>
                      <input
                        type="text"
                        name="section1_name"
                        value={formData.section1_name}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md"
                        placeholder="कुटुंब प्रमुखाचे नाव प्रविष्ट करा"
                      />
                    </div>
                    <div>
                      <label className="block font-semibold text-gray-700 mb-2">पत्ता</label>
                      <input
                        type="text"
                        name="section1_address"
                        value={formData.section1_address}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md"
                        placeholder="पत्ता प्रविष्ट करा"
                      />
                    </div>
                  </div>
                </div>

                {/* Section 2 */}
                <div>
                  <h3 className="font-bold text-lg mb-2">२. बँक खात्याचा तपशील</h3>
                  <div className="grid grid-cols-3 gap-4">
                    <div>
                      <label className="block font-semibold text-gray-700 mb-2">बँकेचे नाव</label>
                      <input
                        type="text"
                        name="section2_bank_name"
                        value={formData.section2_bank_name}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md"
                        placeholder="बँकेचे नाव प्रविष्ट करा"
                      />
                    </div>
                    <div>
                      <label className="block font-semibold text-gray-700 mb-2">खाते क्रमांक</label>
                      <input
                        type="text"
                        name="section2_account_number"
                        value={formData.section2_account_number}
                        onChange={handleInputChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md"
                        placeholder="खाते क्रमांक प्रविष्ट करा"
                      />
                    </div>
                  </div>
                </div>

                {/* Section 3 */}
                <div>
                  <h3 className="font-bold text-lg mb-2">३. घराचे स्वरूप</h3>
                  <select
                    name="section3_text"
                    value={formData.section3_text}
                    onChange={handleInputChange}
                    className="w-50 px-3 py-2 border border-gray-300 rounded-md mb-2"
                  >
                    <option value="">निवडा</option>
                    <option value="पक्के">पक्के</option>
                    <option value="कच्चे">कच्चे</option>
                    <option value="आर.सी.सी.">आर.सी.सी.</option>
                    <option value="इतर">इतर</option>
                  </select>
                  {formData.section3_text === 'इतर' && (
                    <input
                      type="text"
                      name="section3_other"
                      value={formData.section3_other}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md"
                      placeholder="इतर तपशील प्रविष्ट करा"
                    />
                  )}
                </div>

                {/* Section 4 */}
                {/* <div>
                  <h3 className="font-bold text-lg mb-2">४. घराचे क्षेत्रफळ</h3>
                  <input
                    type="number"
                    name="section4_text"
                    value={formData.section4_text}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md"
                    placeholder="चौ.फुट/चौ.मी."
                  />
                </div> */}

                {/* Section 4 */}
                <div>
                  <h3 className="font-bold text-lg mb-2">४. घराचे क्षेत्रफळ</h3>

                  <div className="grid grid-cols-3 gap-4">
                    {/* घराचे एकूण क्षेत्र */}
                    <div>
                      <label className="block font-semibold text-gray-700 mb-1">
                        घराचे एकूण क्षेत्र
                      </label>
                      <input
                        type="number"
                        value={formData.section6_rows[0]?.totalArea}
                        onChange={(e) =>
                          handleTableChange(
                            "section6_rows",
                            0,
                            "totalArea",
                            e.target.value
                          )
                        }
                        className="w-full px-3 py-2 border border-gray-300 rounded-md"
                      />
                    </div>

                    {/* बांधकाम क्षेत्र */}
                    <div>
                      <label className="block font-semibold text-gray-700 mb-1">
                        बांधकाम क्षेत्र
                      </label>
                      <input
                        type="number"
                        value={formData.section6_rows[0]?.constructionArea}
                        onChange={(e) =>
                          handleTableChange(
                            "section6_rows",
                            0,
                            "constructionArea",
                            e.target.value
                          )
                        }
                        className="w-full px-3 py-2 border border-gray-300 rounded-md"
                      />
                    </div>

                    {/* संपादित क्षेत्र */}
                    <div>
                      <label className="block font-semibold text-gray-700 mb-1">
                        संपादित क्षेत्र
                      </label>
                      <input
                        type="number"
                        value={formData.section6_rows[0]?.acquiredArea}
                        onChange={(e) =>
                          handleTableChange(
                            "section6_rows",
                            0,
                            "acquiredArea",
                            e.target.value
                          )
                        }
                        className="w-full px-3 py-2 border border-gray-300 rounded-md"
                      />
                    </div>
                  </div>
                </div>
                </fieldset>        

                {/* Section 5 Table */}
                <div>
                  <h3 className="font-bold text-lg mb-2">५. कुटुंबातील सदस्यांची माहिती</h3>

                  {/* ✅ Header Labels */}
                  <div className="grid grid-cols-10 gap-2 font-semibold text-sm bg-gray-100 border border-gray-300 p-2 rounded-md mb-2">
                    <div>अ.क्र.</div>
                    <div>नाव</div>
                    <div>वय (वर्षे)</div>
                    <div>कुटुंब प्रमुखाशी नाते</div>
                    <div>उत्पनाचे साधन</div>
                    <div>अंदाजे वार्षिक उत्पन्न (रु.)</div>
                    <div>अपंगत्व</div>
                    <div>जन्मतारीख</div>   
                    <div>मृत्यू तारीख</div> 
                    <div className="text-center">Actions</div>
                  </div>

                  {formData.landDetails.map((row, index) => (
                    <div
                      key={index}
                      className="grid grid-cols-10 gap-2 mb-2 items-start"
                    >
                      <input
                        type="text"
                        value={row.sr}
                        readOnly
                        className="px-2 py-1 border bg-gray-100 rounded text-center"
                        disabled={isDRO}
                      />
                      <input
                        type="text"
                        placeholder="नाव"
                        value={row.name}
                        onChange={(e) =>
                          handleTableChange("landDetails", index, "name", e.target.value)
                        }
                        className="px-2 py-1 border rounded w-full"
                        disabled={isDRO}
                      />
                      <input
                        type="number"
                        placeholder="वय वर्षे"
                        value={row.age}
                        onChange={(e) =>
                          handleTableChange("landDetails", index, "age", e.target.value)
                        }
                        className="px-2 py-1 border rounded w-full"
                        disabled={isDRO}
                      />
                      <select
                        value={row.relation}
                        onChange={(e) =>
                          handleTableChange("landDetails", index, "relation", e.target.value)
                        }
                        className="px-2 py-1 border rounded w-full"
                        disabled={isDRO}
                      >
                        <option value="">कुटुंब प्रमुखाशी नाते</option>
                        <option value="स्वयं">स्वयं</option>
                        <option value="पती">पती</option>
                        <option value="पत्नी">पत्नी</option>
                        <option value="मुलगा">मुलगा</option>
                        <option value="मुलगी">मुलगी</option>
                        <option value="वडील">वडील</option>
                        <option value="आई">आई</option>
                        <option value="भाऊ">भाऊ</option>
                        <option value="बहीण">बहीण</option>
                        <option value="इतर">इतर</option>
                      </select>
                      <input
                        type="text"
                        placeholder="उत्पनाचे साधन"
                        value={row.occupation}
                        onChange={(e) =>
                          handleTableChange("landDetails", index, "occupation", e.target.value)
                        }
                        className="px-2 py-1 border rounded w-full"
                        disabled={isDRO}
                      />
                      <input
                        type="number"
                        placeholder="अंदाजे वार्षिक उत्पन्न (रु.)"
                        value={row.annualIncome}
                        onChange={(e) =>
                          handleTableChange("landDetails", index, "annualIncome", e.target.value)
                        }
                        className="px-2 py-1 border rounded w-full"
                        disabled={isDRO}
                      />

                      {/* ✅ अपंगत्व Section */}
                      <div>
                        <select
                          value={row.disabled}
                          onChange={(e) =>
                            handleTableChange("landDetails", index, "disabled", e.target.value)
                          }
                          className="px-2 py-1 border rounded w-full"
                          disabled={isDRO}
                        >
                          <option value="">
                            मानसिक अथवा शारीरिक दृष्ट्या अपंग आहे का ?
                          </option>
                          <option value="होय">होय</option>
                          <option value="नाही">नाही</option>
                        </select>

                        {row.disabled === "होय" && (
                          <div className="mt-2">
                            <select
                              value={row.physically_disabled_type}
                              onChange={(e) =>
                                handleTableChange(
                                  "landDetails",
                                  index,
                                  "physically_disabled_type",
                                  e.target.value
                                )
                              }
                              className="px-2 py-1 border rounded w-full"
                            >
                              <option value="">निवडा</option>
                              <option value="कर्णबधीर">कर्णबधीर</option>
                              <option value="मुखबधीर">मुखबधीर</option>
                              <option value="अंध">अंध</option>
                              <option value="अस्तीव्यंग">अस्तीव्यंग</option>
                              <option value="इतर">इतर</option>
                            </select>

                            {row.physically_disabled_type === "इतर" && (
                              <input
                                type="text"
                                placeholder="इतर अपंगत्व तपशील"
                                value={row.physically_disabled_type_other}
                                onChange={(e) =>
                                  handleTableChange(
                                    "landDetails",
                                    index,
                                    "physically_disabled_type_other",
                                    e.target.value
                                  )
                                }
                                className="px-2 py-1 border rounded w-full mt-2"
                              />
                            )}
                          </div>
                        )}
                      </div>

                      {/* birth_date */}
                    <input
                      type="date"
                      value={row.birth_date || ''}
                      onChange={(e) =>
                        handleTableChange("landDetails", index, "birth_date", e.target.value)
                      }
                      className="px-2 py-1 border rounded w-full"
                      disabled={isDRO}
                    />

                    {/* death_date */}
                    <td className="border p-2">
                      <select
                        value={row.isDeath || 'नाही'}
                        onChange={(e) =>
                          handleTableChange("landDetails", index, "isDeath", e.target.value)
                        }
                        className="border rounded px-2 py-1"
                        disabled={isDRO}
                      >
                        <option value="नाही">नाही</option>
                        <option value="होय">होय</option>
                      </select>

                      {/* 👇 Show date only when "होय" */}
                      {row.isDeath === 'होय' && (
                        <input
                          type="date"
                          value={row.death_date || ''}
                          onChange={(e) =>
                            handleTableChange("landDetails", index, "death_date", e.target.value)
                          }
                          className="border rounded px-2 py-1 mt-1 block"
                          disabled={isDRO}
                        />
                      )}
                    </td>

                      {/* ✅ Action Buttons */}
                      <div className="flex gap-2 justify-center">
                      {userRole !== ROLES.DRO && (
                      <div>
                        {row.isNew ? (
                          <button
                            onClick={() => handleAddFamilyMember(row, index)}
                            disabled={savingRowIndex === index && savingType === "add"}
                            className={`flex items-center justify-center gap-2 px-2 py-1 rounded text-white text-sm ${
                              savingRowIndex === index && savingType === "add"
                                ? "bg-blue-400 cursor-not-allowed"
                                : "bg-blue-500 hover:bg-blue-600"
                            }`}
                          >
                            {savingRowIndex === index && savingType === "add" ? (
                              <>
                                <div className="animate-spin h-3 w-3 border-2 border-white border-t-transparent rounded-full"></div>
                              </>
                            ) : (
                              <Save size={16} />
                            )}
                          </button>
                        ) : (
                          <button
                            onClick={() =>
                              handleUpdateFamilyMember(row.family_id, row, index)
                            }
                            disabled={isDRO && savingRowIndex === index && savingType === "update"}
                            className={`flex items-center justify-center gap-2 px-2 py-1 rounded text-white text-sm ${
                              savingRowIndex === index && savingType === "update"
                                ? "bg-yellow-400 cursor-not-allowed"
                                : "bg-yellow-500 hover:bg-yellow-600"
                            }`}
                          >
                            {savingRowIndex === index && savingType === "update" ? (
                              <>
                                <div className="animate-spin h-3 w-3 border-2 border-white border-t-transparent rounded-full"></div>
                              </>
                            ) : (
                              <Save size={16} />
                            )}
                          </button>
                        )}
                        </div>
                      )}

                        <button
                          onClick={() => handleDeleteFamilyMember(row.family_id, index)}
                          className="px-2 py-1 bg-red-500 text-white rounded hover:bg-red-600 text-sm"
                        >
                          <Trash2 size={16} />
                        </button>
                      </div>
                    </div>
                  ))}

                  {userRole !== ROLES.DRO && (
                  <div>
                  {/* ✅ Add Button */}
                  <button
                    onClick={() =>
                      addTableRow("landDetails", {
                        name: "",
                        age: "",
                        relation: "",
                        occupation: "",
                        annualIncome: "",
                        disabled: "",
                        disabled_type: "",
                        disabled_other: "",
                        physically_disabled_type: "",
                        physically_disabled_type_other: "",
                        birth_date: '',
                        death_date: '',
                        isNew: true,
                      })
                    }
                    className="mt-2 px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
                  >
                    Add
                  </button>
                  </div>
                  )}
                </div>

                <fieldset disabled={userRole === ROLES.DRO}> 
                {/* Section 6 Table */}
                    <div>
                    <h3 className="font-bold text-lg mb-2">६. शेती आहे काय ?</h3>
                    <select
                      name="section6_has_land"
                      value={formData.section6_has_land}
                      onChange={handleInputChange}
                      className="w-50 px-3 py-2 border border-gray-300 rounded-md mb-2"
                    >
                      <option value="">निवडा</option>
                      <option value="होय">होय</option>
                      <option value="नाही">नाही</option>
                    </select>

                    {formData.section6_has_land === "होय" && (
                      <div>
                        {formData.section6_rows.map((row, index) => (
                          <div key={index} className="grid grid-cols-4 gap-4 mb-4">
                            <div>
                              <label className="block text-sm  mb-1 font-semibold">गाव</label>
                              <input
                                type="text"
                                placeholder="गाव"
                                value={row.village}
                                disabled
                                onChange={(e) =>
                                  handleTableChange("section6_rows", index, "village", e.target.value)
                                }
                                className="w-full px-2 py-1 border rounded"
                              />
                            </div>

                            <div>
                              <label className="block text-sm  mb-1 font-semibold">गट क्रमांक</label>
                              <input
                                type="text"
                                placeholder="गट क्रमांक"
                                value={row.gatNo}
                                onChange={(e) =>
                                  handleTableChange("section6_rows", index, "gatNo", e.target.value)
                                }
                                className="w-full px-2 py-1 border rounded"
                              />
                            </div>

                            <div>
                              <label className="block text-sm  mb-1 font-semibold">एकूण क्षेत्र</label>
                              <input
                                type="text"
                                placeholder="एकूण क्षेत्र"
                                value={row.familytotalarea}
                                onChange={(e) =>
                                  handleTableChange("section6_rows", index, "familytotalarea", e.target.value)
                                }
                                className="w-full px-2 py-1 border rounded"
                                required
                              />
                            </div>

                            <div>
                              <label className="block text-sm  mb-1 font-semibold">संपादित क्षेत्र</label>
                              <input
                                type="text"
                                placeholder="संपादित क्षेत्र"
                                value={row.familyacquirearea}
                                onChange={(e) =>
                                  handleTableChange("section6_rows", index, "familyacquirearea", e.target.value)
                                }
                                className="w-full px-2 py-1 border rounded"
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>


                {/* Section 7 Table */}
                <div>
                  <h3 className="font-bold text-lg mb-2">७. गुरे आहे काय ?</h3>
                  <select
                    name="section7_has_livestock"
                    value={formData.section7_has_livestock}
                    onChange={handleInputChange}
                    className="w-50 px-3 py-2 border border-gray-300 rounded-md mb-2"
                  >
                    <option value="">निवडा</option>
                    <option value="होय">होय</option>
                    <option value="नाही">नाही</option>
                  </select>

                  {formData.section7_has_livestock === 'होय' && (
                    <div>
                      {/* ✅ Header Labels */}
                      <div className="grid grid-cols-6 gap-2 font-semibold text-sm bg-gray-100 border border-gray-300 p-2 rounded-md mb-2">
                        <div>जनावराचा प्रकार</div>
                        <div>संख्या</div>
                        <div>त्यापासून होणारे उत्पन्न</div>
                        <div>शेरा</div>
                        {userRole !== ROLES.DRO && (
                        <div className="text-center">Save / Update</div>
                        )}
                        {userRole !== ROLES.DRO && (
                        <div className="text-center">Delete</div>
                        )}
                      </div>

                      {formData.section7_rows.map((row, index) => (
                        <div key={index} className="grid grid-cols-6 gap-2 mb-2 items-center">
                          <input
                            type="text"
                            placeholder="जनावराचा प्रकार"
                            value={row.property_name}
                            onChange={(e) =>
                              handleTableChange('section7_rows', index, 'property_name', e.target.value)
                            }
                            className="px-2 py-1 border rounded"
                          />
                          <input
                            type="number"
                            placeholder="संख्या"
                            value={row.property_count}
                            onChange={(e) =>
                              handleTableChange('section7_rows', index, 'property_count', e.target.value)
                            }
                            className="px-2 py-1 border rounded"
                          />
                          <input
                            type="number"
                            placeholder="त्यापासून होणारे उत्पन्न"
                            value={row.product_from_property}
                            onChange={(e) =>
                              handleTableChange('section7_rows', index, 'product_from_property', e.target.value)
                            }
                            className="px-2 py-1 border rounded"
                          />
                          <input
                            type="text"
                            placeholder="शेरा"
                            value={row.remarks}
                            onChange={(e) =>
                              handleTableChange('section7_rows', index, 'remarks', e.target.value)
                            }
                            className="px-2 py-1 border rounded"
                          />

                            {userRole !== ROLES.DRO && (
                            <div className='flex items-center justify-center gap-2 px-2 py-1 rounded text-white text-sm'>
                          {/* ✅ Save / Update button */}
                          {row.isNew ? (
                            <button
                              onClick={() => handleAddAnimalProperty(row, index)}
                              disabled={savingRowIndex === index && savingType === "add"}
                              className={`flex items-center justify-center gap-2 px-2 py-1 rounded text-white text-sm ${
                                savingRowIndex === index && savingType === "add"
                                  ? "bg-blue-400 cursor-not-allowed"
                                  : "bg-blue-500 hover:bg-blue-600"
                              }`}
                            >
                              {savingRowIndex === index && savingType === "add" ? (
                                <>
                                  <div className="animate-spin h-3 w-3 border-2 border-white border-t-transparent rounded-full"></div>
                                </>
                              ) : (
                                <Save size={16} />
                              )}
                            </button>
                          ) : (
                            <button
                              onClick={() => handleUpdateAnimalProperty(row.property_id, row, index)}
                              disabled={savingRowIndex === index && savingType === "update"}
                              className={`flex items-center justify-center gap-2 px-2 py-1 rounded text-white text-sm ${
                                savingRowIndex === index && savingType === "update"
                                  ? "bg-yellow-400 cursor-not-allowed"
                                  : "bg-yellow-500 hover:bg-yellow-600"
                              }`}
                            >
                              {savingRowIndex === index && savingType === "update" ? (
                                <>
                                  <div className="animate-spin h-3 w-3 border-2 border-white border-t-transparent rounded-full"></div>
                                </>
                              ) : (
                                <Save size={16} />
                              )}
                            </button>
                          )}
                          </div>
                            )}

                          {userRole !== ROLES.DRO && (
                          <div className='flex items-center justify-center gap-2 px-2 py-1 rounded text-white text-sm'>  
                          {/* ✅ Delete button */}
                          <button
                            onClick={() => handleDeleteAnimalProperty(row.property_id, index)}
                            className={`flex justify-center px-3 py-1 text-sm rounded text-white ${
                              row.property_id 
                                ? "bg-red-600 hover:bg-red-700" 
                                : "bg-gray-400 cursor-not-allowed"
                            }`}
                            disabled={!row.property_id}   // disable for unsaved rows
                          >
                            <Trash2 size={16} />
                          </button>
                          </div>
                          )}
                        </div>
                      ))}

                      {userRole !== ROLES.DRO && (
                      <button
                        onClick={() =>
                          addTableRow('section7_rows', {
                            type: '',
                            number: '',
                            area: '',
                            note: '',
                            compensation: '',
                            isNew: true,
                          })
                        }
                        className="mt-2 px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
                      >
                        Add
                      </button>
                      )}

                      {/* ✅ गोठा आहे काय? - single dropdown + conditional input */}
                      <div className="mt-4">
                        <label className="block font-semibold mb-1">गोठा आहे काय ?</label>
                        <select
                          name="section7_has_shed"
                          value={formData.section7_has_shed || ''}
                          onChange={(e) =>
                            setFormData((prev) => ({ ...prev, section7_has_shed: e.target.value }))
                          }
                          className="w-50 px-3 py-2 border border-gray-300 rounded-md"
                        >
                          <option value="">निवडा</option>
                          <option value="होय">होय</option>
                          <option value="नाही">नाही</option>
                        </select>

                        {formData.section7_has_shed === 'होय' && (
                          <input
                            type="text"
                            placeholder="गोठा तपशील प्रविष्ट करा"
                            value={formData.section7_gotha_details || ''}
                            onChange={(e) =>
                              setFormData((prev) => ({
                                ...prev,
                                section7_gotha_details: e.target.value,
                              }))
                            }
                            className="mt-2 w-full px-3 py-2 border border-gray-300 rounded-md"
                          />
                        )}
                      </div>
                    </div>
                  )}
                </div>


                {/* Section 8 Table */}
                <div>
                  <h3 className="font-bold text-lg mb-2">८. कुटुंबाची इतर स्थावर मालमत्ता आहे काय ?</h3>
                  <select
                    name="section8_has_property"
                    value={formData.section8_has_property}
                    onChange={handleInputChange}
                    className="w-50 px-3 py-2 border border-gray-300 rounded-md mb-2"
                  >
                    <option value="">निवडा</option>
                    <option value="होय">होय</option>
                    <option value="नाही">नाही</option>
                  </select>

                  {formData.section8_has_property === "होय" && (
                    <div>
                      {/* ✅ Header Labels */}
                      <div className="grid grid-cols-6 gap-2 font-semibold text-sm bg-gray-100 border border-gray-300 p-2 rounded-md mb-2">
                        <div>मालमत्तेचा प्रकार</div>
                        <div>मालमत्ताधारकाचे नाव</div>
                        <div>कुटुंबप्रमुखाचे नाते</div>
                        {/* <div>संख्या</div> */}
                        <div>उत्पन्न</div>
                        {/* <div>नुकसान भरपाई</div> */}
                        <div>शेरा</div>
                        {userRole !== ROLES.DRO && (
                        <div className="text-center">Actions</div>
                        )}
                      </div>

                      {formData.section8_rows.map((row, index) => (
                        <div
                          key={index}
                          className="grid grid-cols-6 gap-2 mb-2 items-center"
                        >
                          <input
                            type="text"
                            placeholder="मालमत्तेचा प्रकार"
                            value={row.property_name}
                            onChange={(e) =>
                              handleTableChange("section8_rows", index, "property_name", e.target.value)
                            }
                            className="px-2 py-1 border rounded w-full"
                          />
                          <input
                            type="text"
                            placeholder="मालमत्ताधारकाचे नाव"
                            value={row.property_owner}
                            onChange={(e) =>
                              handleTableChange("section8_rows", index, "property_owner", e.target.value)
                            }
                            className="px-2 py-1 border rounded w-full"
                          />
                          <input
                            type="text"
                            placeholder="कुटुंबप्रमुखाचे नाते"
                            value={row.property_owner_realtion}
                            onChange={(e) =>
                              handleTableChange("section8_rows", index, "property_owner_realtion", e.target.value)
                            }
                            className="px-2 py-1 border rounded w-full"
                          />
                          {/* <input
                            type="number"
                            placeholder="संख्या"
                            value={row.property_count}
                            onChange={(e) =>
                              handleTableChange("section8_rows", index, "property_count", e.target.value)
                            }
                            className="px-2 py-1 border rounded w-full"
                          /> */}
                          <input
                            type="number"
                            placeholder="उत्पन्न"
                            value={row.product_from_property}
                            onChange={(e) =>
                              handleTableChange("section8_rows", index, "product_from_property", e.target.value)
                            }
                            className="px-2 py-1 border rounded w-full"
                          />
                          {/* <input
                            type="number"
                            placeholder="नुकसान भरपाई"
                            value={row.has_cowshed}
                            onChange={(e) =>
                              handleTableChange("section8_rows", index, "has_cowshed", e.target.value)
                            }
                            className="px-2 py-1 border rounded w-full"
                          /> */}
                          <input
                            type="text"
                            placeholder="शेरा"
                            value={row.remarks}
                            onChange={(e) =>
                              handleTableChange("section8_rows", index, "remarks", e.target.value)
                            }
                            className="px-2 py-1 border rounded w-full"
                          />

                          {/* ✅ Save / Update + Delete Buttons */}
                          <div className="flex gap-2 justify-center">
                          {userRole !== ROLES.DRO && (
                          <div>
                            {row.isNew ? (
                              <button
                                onClick={() => handleAddFamilyProperty(row, index)}
                                disabled={savingRowIndex === index && savingType === "add"}
                                className={`flex items-center justify-center gap-2 px-2 py-1 rounded text-white text-sm ${
                                  savingRowIndex === index && savingType === "add"
                                    ? "bg-blue-400 cursor-not-allowed"
                                    : "bg-blue-500 hover:bg-blue-600"
                                }`}
                              >
                                {savingRowIndex === index && savingType === "add" ? (
                                  <>
                                    <div className="animate-spin h-3 w-3 border-2 border-white border-t-transparent rounded-full"></div>
                                  </>
                                ) : (
                                  <Save size={16} />
                                )}
                              </button>
                            ) : (
                              <button
                                onClick={() =>
                                  handleUpdateFamilyProperty(row.property_id, row, index)
                                }
                                disabled={savingRowIndex === index && savingType === "update"}
                                className={`flex items-center justify-center gap-2 px-2 py-1 rounded text-white text-sm ${
                                  savingRowIndex === index && savingType === "update"
                                    ? "bg-yellow-400 cursor-not-allowed"
                                    : "bg-yellow-500 hover:bg-yellow-600"
                                }`}
                              >
                                {savingRowIndex === index && savingType === "update" ? (
                                  <>
                                    <div className="animate-spin h-3 w-3 border-2 border-white border-t-transparent rounded-full"></div>
                                  </>
                                ) : (
                                  <Save size={16} />
                                )}
                              </button>
                            )}
                            </div>
                          )}

                          {userRole !== ROLES.DRO && (
                            <div>
                            <button
                              onClick={() => handleDeleteFamilyProperty(row.property_id, index)}
                              disabled={!row.property_id || savingRowIndex === index}
                              className={`px-3 py-1 rounded text-white text-sm  ${
                                row.property_id
                                  ? "bg-red-600 hover:bg-red-700"
                                  : "bg-gray-400 cursor-not-allowed"
                              }`}
                            >
                              <Trash2 size={16} />
                            </button>
                            </div>
                          )}
                          </div>
                        </div>
                      ))}

                      {userRole !== ROLES.DRO && (
                      <button
                        onClick={() =>
                          addTableRow("section8_rows", {
                            property_type: "",
                            property_name: "",
                            property_count: "",
                            product_from_property: "",
                            property_owner:"",
                            property_owner_realtion:"",
                            has_cowshed: "",
                            remarks: "",
                            isNew: true,
                          })
                        }
                        className="mt-2 px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
                      >
                        Add
                      </button>
                      )}
                    </div>
                  )}
                </div>


                {/* Section 9 */}
                <div>
                  <h3 className="font-bold text-lg mb-2">९. सामाजिकदृष्ट्या दुर्बल घटक आहे काय?</h3>
                  <select
                    name="section9_has_vulnerability"
                    value={formData.section9_has_vulnerability}
                    onChange={handleInputChange}
                    className="w-50 px-3 py-2 border border-gray-300 rounded-md mb-2"
                  >
                    <option value="">निवडा</option>
                    <option value="होय">होय</option>
                    <option value="नाही">नाही</option>
                  </select>
                  {formData.section9_has_vulnerability === 'होय' && (
                    <textarea
                      name="section9_text"
                      value={formData.section9_text}
                      onChange={handleInputChange}
                      rows="3"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md"
                      placeholder="कुटुंब सामाजिकदृष्ट्या दुर्बल घटकातील आहे काय? असल्यास तपशील"
                    />
                  )}
                </div>

                {/* Section 10 */}
                <div>
                  <h3 className="font-bold text-lg mb-2">१०. कुटुंबातील माहितीबाबत सादर केलेल्या पुरावाचा तपशील</h3>
                  <div className="grid grid-cols-2 gap-4 mb-4 p-4 bg-gray-50 rounded">
                    <div>
                      <label className="block text-sm font-semibold mb-1">मालकाचे नाव:</label>
                      <input
                        type="text"
                        placeholder="नाव"
                        value={formData.section10_rows[0]?.rationCard || ''}
                        onChange={(e) => handleTableChange('section10_rows', 0, 'rationCard', e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-semibold mb-1">राशन कार्ड क्र.:</label>
                      <input
                        type="number"
                        placeholder="राशन कार्ड क्र."
                        value={formData.section10_rows[0]?.rationCardNo || ''}
                        onChange={(e) => handleTableChange('section10_rows', 0, 'rationCardNo', e.target.value)}
                        className="w-full px-3 py-2 border border-gray-300 rounded"
                      />
                    </div>
                  </div>

                  <div className="overflow-x-auto">
                    <table className="w-full border-collapse border border-gray-300">
                      <thead>
                        <tr className="bg-gray-100">
                          <th className="border border-gray-300 p-2 text-sm">कुटुंबाचे सदस्याचे नाव</th>
                          <th className="border border-gray-300 p-2 text-sm">आधार कार्ड क्र.</th>
                          {userRole !== ROLES.DRO && (
                          <th className="border border-gray-300 p-2 text-sm">Actions</th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {formData.section10_rows.map((row, index) => (
                          <tr key={index} className="border-b">
                            <td className="border border-gray-300 p-1">
                              <input
                                type="text"
                                placeholder="कुटुंब सदस्याचे नाव"
                                value={row.ownerName}
                                onChange={(e) =>
                                  handleTableChange("section10_rows", index, "ownerName", e.target.value)
                                }
                                className="w-full px-2 py-1 border rounded"
                              />
                            </td>
                            <td className="border border-gray-300 p-1">
                              <input
                                type="number"
                                placeholder="आधार कार्ड क्र."
                                value={row.aadharCard}
                                onChange={(e) =>
                                  handleTableChange("section10_rows", index, "aadharCard", e.target.value)
                                }
                                className="w-full px-2 py-1 border rounded"
                              />
                            </td>
                            {userRole !== ROLES.DRO && (
                            <td className="border border-gray-300 p-1 text-center">
                              <div className="flex gap-2 justify-center">
                                {row.isNew ? (
                                  <button
                                    onClick={() => handleAddSection10Member(row, index)}
                                    disabled={savingRowIndex === index && savingType === "add"}
                                    className={`flex items-center justify-center gap-2 px-2 py-1 rounded text-white text-sm ${
                                      savingRowIndex === index && savingType === "add"
                                        ? "bg-blue-400 cursor-not-allowed"
                                        : "bg-blue-500 hover:bg-blue-600"
                                    }`}
                                  >
                                    {savingRowIndex === index && savingType === "add" ? (
                                      <>
                                        <div className="animate-spin h-3 w-3 border-2 border-white border-t-transparent rounded-full"></div>
                                        Saving...
                                      </>
                                    ) : (
                                      "Save"
                                    )}
                                  </button>
                                ) : (
                                  <button
                                    onClick={() =>
                                      handleUpdateSection10Member(row.family_id, row, index)
                                    }
                                    disabled={savingRowIndex === index && savingType === "update"}
                                    className={`flex items-center justify-center gap-2 px-2 py-1 rounded text-white text-sm ${
                                      savingRowIndex === index && savingType === "update"
                                        ? "bg-yellow-400 cursor-not-allowed"
                                        : "bg-yellow-500 hover:bg-yellow-600"
                                    }`}
                                  >
                                    {savingRowIndex === index && savingType === "update" ? (
                                      <>
                                        <div className="animate-spin h-3 w-3 border-2 border-white border-t-transparent rounded-full"></div>
                                        Updating...
                                      </>
                                    ) : (
                                      <Save size={16} />
                                    )}
                                  </button>
                                )}

                                {/* <button
                                  onClick={() => removeTableRow("section10_rows", index)}
                                  className="px-2 py-1 bg-red-500 text-white rounded hover:bg-red-600 text-sm"
                                  disabled={formData.section10_rows.length === 1}
                                >
                                  Delete
                                </button> */}
                              </div>
                            </td>
                            )}
                          </tr>
                        ))}
                      </tbody>

                    </table>
                  </div>
                  {/* <button
                    onClick={() =>
                      addTableRow('section10_rows', {
                        rationCard: formData.section10_rows[0]?.rationCard || '',
                        rationCardNo: formData.section10_rows[0]?.rationCardNo || '',
                        ownerName: '',
                        aadharCard: '',
                        aadharCardNo: '',
                        isNew: true, // ✅ mark as new
                      })
                    }
                    className="mt-2 px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
                  >
                    Add Row
                  </button> */}

                </div>

                {/* Section 11 Table */}
                <div>
                  <h3 className="font-bold text-lg mb-2">११. कुटुंबाचे व्यावसायिक आस्थापना च्या कंपन आहे काय?</h3>
                  <select
                    name="section11_has_business"
                    value={formData.section11_has_business}
                    onChange={handleInputChange}
                    className="w-50 px-3 py-2 border border-gray-300 rounded-md mb-2"
                  >
                    <option value="">निवडा</option>
                    <option value="होय">होय</option>
                    <option value="नाही">नाही</option>
                  </select>

                  {formData.section11_has_business === "होय" && (
                    <div>
                      {/* ✅ Header Labels */}
                      <div className="grid grid-cols-5 gap-2 font-semibold text-sm bg-gray-100 border border-gray-300 p-2 rounded-md mb-2">
                        <div>कुटुंबातील सदस्याचे नाव</div>
                        <div>व्यावसायिक कौशल्य</div>
                        <div>त्यापासून होणारे उत्पन्न</div>
                        <div>शेरा</div>
                        {userRole !== ROLES.DRO && (
                        <div className="text-center">Actions</div>
                        )}
                      </div>

                      {formData.section11_rows.map((row, index) => (
                        <div
                          key={index}
                          className="grid grid-cols-5 gap-2 mb-2 items-center"
                        >
                          <input
                            type="text"
                            placeholder="कुटुंबातील सदस्याचे नाव"
                            value={row.name}
                            onChange={(e) =>
                              handleTableChange("section11_rows", index, "name", e.target.value)
                            }
                            className="px-2 py-1 border rounded w-full"
                          />
                          <input
                            type="text"
                            placeholder="व्यावसायिक कौशल्य"
                            value={row.commercial_code}
                            onChange={(e) =>
                              handleTableChange("section11_rows", index, "commercial_code", e.target.value)
                            }
                            className="px-2 py-1 border rounded w-full"
                          />
                          <input
                            type="number"
                            placeholder="त्यापासून होणारे उत्पन्न"
                            value={row.compensation}
                            onChange={(e) =>
                              handleTableChange("section11_rows", index, "compensation", e.target.value)
                            }
                            className="px-2 py-1 border rounded w-full"
                          />
                          <input
                            type="text"
                            placeholder="शेरा"
                            value={row.total}
                            onChange={(e) =>
                              handleTableChange("section11_rows", index, "total", e.target.value)
                            }
                            className="px-2 py-1 border rounded w-full"
                          />

                          {userRole !== ROLES.DRO && (
                            <div>
                          {/* ✅ Action Buttons */}
                          <div className="flex gap-2 justify-center">
                            {row.isNew ? (
                              <button
                                onClick={() => handleAddSection11Member(row, index)}
                                disabled={savingRowIndex === index && savingType === "add"}
                                className={`flex items-center justify-center gap-2 px-2 py-1 rounded text-white text-sm ${
                                  savingRowIndex === index && savingType === "add"
                                    ? "bg-blue-400 cursor-not-allowed"
                                    : "bg-blue-500 hover:bg-blue-600"
                                }`}
                              >
                                {savingRowIndex === index && savingType === "add" ? (
                                  <>
                                    <div className="animate-spin h-3 w-3 border-2 border-white border-t-transparent rounded-full"></div>
                                    Saving...
                                  </>
                                ) : (
                                  "Save"
                                )}
                              </button>
                            ) : (
                              <button
                                onClick={() => handleUpdateSection11Member(row.family_id, row, index)}
                                disabled={savingRowIndex === index && savingType === "update"}
                                className={`flex items-center justify-center gap-2 px-2 py-1 rounded text-white text-sm ${
                                  savingRowIndex === index && savingType === "update"
                                    ? "bg-yellow-400 cursor-not-allowed"
                                    : "bg-yellow-500 hover:bg-yellow-600"
                                }`}
                              >
                                {savingRowIndex === index && savingType === "update" ? (
                                  <>
                                    <div className="animate-spin h-3 w-3 border-2 border-white border-t-transparent rounded-full"></div>
                                    Updating...
                                  </>
                                ) : (
                                  <Save size={16} />
                                )}
                              </button>
                            )}

                            {/* <button
                              onClick={() => removeTableRow("section11_rows", index)}
                              className="px-2 py-1 bg-red-500 text-white rounded hover:bg-red-600 text-sm"
                              disabled={formData.section11_rows.length === 1}
                            >
                              Delete
                            </button> */}
                          </div>
                          </div>
                      )}
                        </div>
                      ))}

                      {/* ✅ Add Button */}
                      {/* <button
                        onClick={() =>
                          addTableRow("section11_rows", {
                            name: "",
                            commercial_code: "",
                            compensation: "",
                            total: "",
                            isNew: true,
                          })
                        }
                        className="mt-2 px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
                      >
                        Add
                      </button> */}
                    </div>
                  )}
                </div>


                {/* Section 12 */}
                <div>
                  <h3 className="font-bold text-lg mb-2">१२. पुनर्वसन आणि पुनर्स्थापनेबाबत मत</h3>
                  <textarea
                    name="section12_details"
                    value={formData.section12_details}
                    onChange={handleInputChange}
                    rows="3"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md"
                    placeholder="पुनर्वसन आणि पुनर्स्थापनेबाबत मत"
                  />
                </div>

                {/* Section 13 */}
                <div>
                  <h3 className="font-bold text-lg mb-2">१३. प्रकल्पग्रस्त व्यक्तिचे प्रमाणपत्र</h3>
                  <div className="grid grid-cols-2 gap-4 mb-2">
                    <div>
                      <label className="block text-sm font-medium text-gray-700">प्रकल्पग्रस्त व्यक्तिचे प्रमाणपत्र हे कोणाच्या नावे पाहिजे आहे?</label>
                      <input
                        type="text"
                        name="section13_certificate_name"
                        value={formData.section13_certificate_name}
                        onChange={handleInputChange}
                        className="mt-1 px-3 py-2 border border-gray-300 rounded-md w-full"
                        placeholder="नाव प्रविष्ट करा"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">प्रकल्पग्रस्त व्यक्तिसोबत उपरोक्त व्यक्तिचे नाते?</label>
                      <select
                        name="section13_relationship"
                        value={formData.section13_relationship}
                        onChange={handleInputChange}
                        className="mt-1 px-3 py-2 border border-gray-300 rounded-md w-full"
                      >
                        <option value="">निवडा</option>
                        <option value="स्वयं"> स्वयं</option>
                        <option value="पती">पती</option>
                        <option value="पत्नी">पत्नी</option>
                        <option value="मुलगा">मुलगा</option>
                        <option value="मुलगी">मुलगी</option>
                        <option value="वडील">वडील</option>
                        <option value="आई">आई</option>
                        <option value="भाऊ">भाऊ</option>
                        <option value="बहीण">बहीण</option>
                        <option value="इतर">इतर</option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* Section 14   */}
                <div>
                  <h3 className="font-bold text-lg mb-2">१४. खातेदाराचा प्रकार </h3>
                  <select
                    name="section14_text"
                    value={formData.section14_text}
                    onChange={handleInputChange}
                    className="w-50 px-3 py-2 border border-gray-300 rounded-md mb-2"
                  >
                    <option value="">निवडा</option>
                    <option value="खातेदार">खातेदार</option>
                    <option value="विगर खातेदार">विगर खातेदार</option>
                  </select>
                </div>

                <div className='m-6 text-sm font-bold date'>
                  <label className="mr-2">दिनांक :-</label>
                  <input
                    type="date"
                    name="surveyDate"
                    value={formData.surveyDate}
                    onChange={handleInputChange}
                    className="border border-gray-300 rounded px-2 py-1 text-sm"
                  />
                </div>
                </fieldset>
              </div>

              <div className="flex justify-end gap-4 mt-6 pt-4 border-t">
                <button
                  onClick={() => setIsEditing(false)}
                  className="px-6 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSave}
                  disabled={isSaving}
                  className={`flex items-center gap-2 px-6 py-2 rounded-md text-white transition-colors ${
                    isSaving ? 'bg-blue-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'
                  }`}
                >
                  {isSaving ? (
                    <>
                      <div className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full"></div>
                      Saving...
                    </>
                  ) : (
                    <>
                      <Save size={16} />
                      Save
                    </>
                  )}
                </button>

              </div>
            </div>
          </div>
        </div>
      )}

      {/* Document Preview */}
      <div className="bg-white shadow-lg rounded-lg overflow-hidden">
        <div 
          ref={documentRef}
          className="p-8"
          style={{
            fontFamily: "'Noto Sans Devanagari', Arial, sans-serif",
            fontSize: "12px",
            lineHeight: "1.4"
          }}
        >
          {/* Header */}
          <div className="text-center font-bold mb-2 text-sm header">
            {projectName ? `${projectName}` : ''}
          </div>

          
          <div className="mb-4 font-bold text-sm text-center header">
            {formData.office}
          </div>
          
          <div className="mb-4 font-bold text-sm text-right home">
            घर क्रमांक = {formData.year}
          </div>

          {/* Main Content Table */}
          <table className="w-full border-collapse border border-black text-xs">
            <tbody>
              <tr>
                <td className="border border-black w-1/12 p-2 text-center font-bold text-sm">१</td>
                <td className="border border-black w-11/12 p-0">
                  <div className="p-2 border-b border-black text-sm">कुटुंब प्रमुखाचे नाव :- {formData.section1_name}</div>
                  <div className="p-2 text-sm">कुटुंबाचा पत्ता :- {formData.section1_address || 'रा. सावली ता. संगामपूर'}</div>
                </td>
              </tr>
              <tr>
                <td className="border border-black text-center p-2 font-bold text-sm">२</td>
                <td className="border border-black p-0">
                  <div className="p-2 border-b border-black text-sm">बँकेचे नाव :- {formData.section2_bank_name}</div>
                  <div className="p-2 text-sm">खाते क्र. :- {formData.section2_account_number}</div>
                </td>
              </tr>
              <tr>
                <td className="border border-black p-2 font-bold text-center text-sm">३</td>
                <td className="border border-black p-2 text-sm" colSpan="7">
                  घराचे स्वरूप :- {formData.section3_text}{formData.section3_text === 'इतर' ? ` (${formData.section3_other})` : ''}
                </td>
              </tr>
              <tr>
                <td className="border border-black text-center p-2 font-bold text-sm">४</td>
                <td className="border border-black p-0">
                  <div className="p-2 border-b border-black text-sm">घराचे एकूण क्षेत्र:- {formData.section6_rows?.[0]?.totalArea || ''}</div>
                  <div className="p-2 border-b border-black text-sm">बांधकाम क्षेत्र :- {formData.section6_rows?.[0]?.constructionArea || ''}</div>
                  <div className="p-2 text-sm">संपादित क्षेत्र :- {formData.section6_rows?.[0]?.acquiredArea || ''}</div>

                </td>
              </tr>
              <tr>
                <td className="border border-black p-2 font-bold align-top text-sm text-center">५</td>
                <td className="border border-black p-0" colSpan="9">
                  <div className="p-2 text-sm">
                    कुटुंबातील सदस्यांची नावे, वय, कुटुंब प्रमुखाशी असलेले नाते, उत्पन्नाचे साधन, अंदाजे वार्षिक उत्पन्न
                  </div>
                  <table className="w-full">
                    <tbody>
                      <tr className='text-sm'>
                        <td className="border border-black p-2 text-center bg-gray-100" style={{ fontWeight: 'bold' }}>अ.क्र.</td>
                        <td className="border border-black p-2 text-center bg-gray-100" style={{ fontWeight: 'bold' }}>नाव</td>
                        <td className="border border-black p-2 text-center bg-gray-100" style={{ fontWeight: 'bold' }}>वय वर्षे</td>
                        <td className="border border-black p-2 text-center bg-gray-100" style={{ fontWeight: 'bold' }}>कुटुंब प्रमुखाशी नाते</td>
                        <td className="border border-black p-2 text-center bg-gray-100" style={{ fontWeight: 'bold' }}>उत्पनाचे साधन</td>
                        <td className="border border-black p-2 text-center bg-gray-100" style={{ fontWeight: 'bold' }}>अंदाजे वार्षिक उत्पन्न (रु.)</td>
                        <td className="border border-black p-2 text-center bg-gray-100" style={{ fontWeight: 'bold' }}>जन्मतारीख</td>
                        <td className="border border-black p-2 text-center bg-gray-100" style={{ fontWeight: 'bold' }}>मृत्यू तारीख</td>
                        <td className="border border-black p-2 text-center bg-gray-100" style={{ fontWeight: 'bold' }}>मानसिक अथवा शारीरिक <br /> दृष्ट्या अपंग आहे का ?</td>
                      </tr>
                      {formData.landDetails.map((row, idx) => (
                        <tr key={idx} className='text-sm'>
                          <td className="border border-black p-2 text-center">{row.sr}</td>
                          <td className="border border-black p-2">{row.name}</td>
                          <td className="border border-black p-2">{row.age}</td>
                          <td className="border border-black p-2">{row.relation}</td>
                          <td className="border border-black p-2">{row.occupation}</td>
                          <td className="border border-black p-2">{row.annualIncome}</td>
                          <td className="border border-black p-2">{formatDate(row.birth_date)}</td>
                          <td className="border border-black p-2">{formatDate(row.death_date)}</td>
                          <td className="border border-black p-2">
                            {row.disabled}{row.disabled === 'होय' && row.disabled_type ? ` (${row.disabled_type}${row.disabled_type === 'इतर' ? `: ${row.disabled_other}` : ''})` : ''}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td className="border border-black p-2 font-bold align-top text-sm text-center">६</td>
                <td className="border border-black p-0" colSpan="7">
                  <div className="font-bold p-2 bg-gray-50 text-sm">
                    शेती आहे काय ? :- {formData.section6_has_land}
                  </div>
                  {formData.section6_has_land === 'होय' && (
                    <table className="w-full border-collapse">
                      <thead>
                        <tr className="bg-gray-50 text-sm">
                          <th className="border border-black p-1 w-1/2 text-left">गाव</th>
                          <th className="border border-black p-1 w-1/4 text-left">गट क्रमांक</th>
                          <th className="border border-black p-1 w-1/4 text-left">एकूण क्षेत्र</th>
                          <th className="border border-black p-1 w-1/4 text-left">संपादित क्षेत्र</th>
                        </tr>
                      </thead>
                      <tbody>
                        {formData.section6_rows.map((row, idx) => (
                          <tr key={idx} className='text-sm'>
                            <td className="border border-black p-2">{row.village}</td>
                            <td className="border border-black p-1">{row.gatNo}</td>
                            <td className="border border-black p-1">{row.familytotalarea}</td>
                            <td className="border border-black p-1">{row.familyacquirearea}</td>
                          </tr>
                        ))}
                        {/* <tr className='text-sm'>
                          <td className="border border-black p-2"></td>
                          <td className="border border-black p-1"></td>
                          <td className="border border-black p-1">संपादित क्षेत्र - {formData.section6_rows[0]?.acquiredArea}</td>
                        </tr> */}
                      </tbody>
                    </table>
                  )}
                </td>
              </tr>
              <tr>
                <td className="border border-black p-2 font-bold align-top text-sm text-center">७</td>
                <td className="border border-black p-0" colSpan="7">
                  <div className="font-bold p-2 text-sm">
                    गुरे आहे काय ? :- {formData.section7_has_livestock}
                  </div>
                  {formData.section7_has_livestock === 'होय' && (
                    <table className="w-full border-collapse">
                      <thead>
                        <tr className="bg-gray-50 text-sm">
                          <th className="border border-black p-1 text-xs">अ.क्र.</th>
                          <th className="border border-black p-1 text-xs">जनावराचा प्रकार</th>
                          <th className="border border-black p-1 text-xs">संख्या</th>
                          <th className="border border-black p-1 text-xs">त्यापासून होणारे उत्पन्न</th>
                        </tr>
                      </thead>
                      <tbody>
                        {formData.section7_rows.map((row, index) => (
                          <tr key={index} className='text-sm'>
                            <td className="border border-black p-1 text-center">{index + 1}</td>
                            <td className="border border-black p-1">{row.property_name}</td>
                            <td className="border border-black p-1">{row.property_count}</td>
                            <td className="border border-black p-1">{row.product_from_property}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                  <div className="font-bold p-2 text-sm">
                    गोठा आहे काय ? :- {formData.section7_has_shed || 'नाही'}
                    {formData.section7_has_shed === 'होय' && formData.section7_gotha_details && (
                      <>
                        <br />
                        गोठा तपशील :- {formData.section7_gotha_details}
                      </>
                    )}
                  </div>
                </td>
              </tr>
              <tr>
                <td className="border border-black p-2 font-bold align-top text-sm text-center">८</td>
                <td className="border border-black p-0" colSpan="7">
                  <div className="font-bold p-2 text-sm">
                    कुटुंबाची इतर स्थावर मालमत्ता आहे काय ? :- {formData.section8_has_property}
                  </div>
                  {formData.section8_has_property === 'होय' && (
                    <table className="w-full border-collapse">
                      <thead>
                        <tr className="bg-gray-50 text-sm">
                          <th className="border border-black p-1 text-xs">अ.क्र.</th>
                          <th className="border border-black p-1 text-xs">मालमत्तेचा प्रकार</th>
                          <th className="border border-black p-1 text-xs">मालमत्ताधारकाचे नाव</th>
                          <th className="border border-black p-1 text-xs">कुटुंबप्रमुखाचे नाते</th>
                          {/* <th className="border border-black p-1 text-xs">संख्या</th> */}
                          <th className="border border-black p-1 text-xs">त्यापासून होणारे उत्पन्न</th>
                          {/* <th className="border border-black p-1 text-xs">नुकसान भरपाई</th> */}
                          <th className="border border-black p-1 text-xs">शेरा</th>
                        </tr>
                      </thead>
                      <tbody>
                        {formData.section8_rows.map((row, index) => (
                          <tr key={index} className='text-sm'>
                            <td className="border border-black p-1 text-center">{index + 1}</td>
                            <td className="border border-black p-1">{row.property_name}</td>
                            <td className="border border-black p-1">{row.property_owner}</td>
                            <td className="border border-black p-1">{row.property_owner_realtion}</td>
                            {/* <td className="border border-black p-1">{row.property_count}</td> */}
                            <td className="border border-black p-1">{row.product_from_property}</td>
                            {/* <td className="border border-black p-1">{row.has_cowshed}</td> */}
                            <td className="border border-black p-1">{row.remarks}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </td>
              </tr>
              <tr>
                <td className="border border-black p-2 font-bold text-sm text-center">९</td>
                <td className="border border-black p-2 text-sm" colSpan="7">
                  कुटुंब सामाजिकदृष्ट्या दुर्बल घटकातील आहे काय? :- {formData.section9_has_vulnerability}
                  {formData.section9_has_vulnerability === 'होय' && formData.section9_text && (
                    <div>तपशील :- {formData.section9_text}</div>
                  )}
                </td>
              </tr>
              <tr>
                <td className="border border-black p-2 font-bold align-top text-sm text-center">१०</td>
                <td className="border border-black p-0" colSpan="7">
                  <div className="font-bold p-2 text-sm">
                    कुटुंबातील माहितीबाबत सादर केलेल्या पुरावाचा तपशील
                  </div>
                  <div className="p-4 bg-gray-50">
                    <div className="grid grid-cols-2 gap-4 mb-2">
                      <div>
                        <span className="block text-sm font-semibold">मालकाचे नाव:</span>
                        <span className="block text-sm">{formData.section10_rows[0]?.rationCard || ''}</span>
                      </div>
                      <div>
                        <span className="block text-sm font-semibold">राशन कार्ड क्र.:</span>
                        <span className="block text-sm">{formData.section10_rows[0]?.rationCardNo || ''}</span>
                      </div>
                    </div>
                  </div>
                  {formData.section10_rows.length > 0 && (
                    <table className="w-full border-collapse border border-black mt-2">
                      <thead>
                        <tr className="bg-gray-50">
                          <th className="border border-black p-2 text-xs font-semibold">कुटुंबाचे सदस्याचे नाव</th>
                          <th className="border border-black p-2 text-xs font-semibold">आधार कार्ड क्र.</th>
                        </tr>
                      </thead>
                      <tbody>
                        {formData.section10_rows.map((row, index) => (
                          <tr key={index} className="text-sm">
                            <td className="border border-black p-2">{row.ownerName || ''}</td>
                            <td className="border border-black p-2">{row.aadharCard || ''}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </td>
              </tr>
              <tr>
                <td className="border border-black p-2 font-bold align-top text-sm text-center">११</td>
                <td className="border border-black p-0" colSpan="7">
                  <div className="font-bold p-2 text-sm">
                    कुटुंबातील सदस्याकडे व्यावसायिक कौशल्य आहे काय? असल्यास त्याचा तपशील
                  </div>
                  {formData.section11_has_business === 'होय' && formData.section11_rows.length > 0 && (
                    <table className="w-full border-collapse text-sm">
                      <thead>
                        <tr className="bg-gray-50">
                          <th className="border border-black p-1 text-xs">अ.क्र.</th>
                          <th className="border border-black p-1 text-xs">कुटुंबातील सदस्याचे नाव</th>
                          <th className="border border-black p-1 text-xs">व्यावसायिक कौशल्य</th>
                          <th className="border border-black p-1 text-xs">त्यापासून होणारे उत्पन्न</th>
                          <th className="border border-black p-1 text-xs">शेरा</th>
                        </tr>
                      </thead>
                      <tbody>
                        {formData.section11_rows.map((row, index) => (
                          <tr key={index}>
                            <td className="border border-black p-1 text-center">{index + 1}</td>
                            <td className="border border-black p-1">{row.name || ''}</td>
                            <td className="border border-black p-1">{row.commercial_code || ''}</td>
                            <td className="border border-black p-1">{row.compensation || ''}</td>
                            <td className="border border-black p-1">{row.total || ''}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </td>
              </tr>
              <tr className='text-sm'>
                <td className="border border-black p-2 font-bold align-top text-center">१२</td>
                <td className="border border-black p-2" colSpan="7">
                  <div className="font-bold mb-2">बाधित कुटुंबाचे पुनर्वसन आणि पुनर्स्थापनेबाबत मत :-</div>
                  <div>{formData.section12_details}</div>
                </td>
              </tr>
              <tr>
                <td className="border border-black p-2 font-bold text-sm text-center">१३</td>
                <td className="border border-black p-2 text-sm" colSpan="7">
                  <div>प्रकल्पग्रस्त व्यक्तिचे प्रमाणपत्र हे कोणाच्या नावे पाहिजे आहे? :- {formData.section13_certificate_name}</div>
                  <div>प्रकल्पग्रस्त व्यक्तिसोबत उपरोक्त व्यक्तिचे नाते? :- {formData.section13_relationship}</div>
                </td>
              </tr>
              <tr>
                <td className="border border-black p-2 font-bold text-center text-sm">खातेदाराचा प्रकार</td>
                <td className="border border-black p-2 text-sm" colSpan="7">
                  खातेदाराचा प्रकार :- {formData.section14_text}
                </td>
              </tr>
            </tbody>
          </table>
          <div className='m-6 text-sm font-bold date'>
            दिनांक :- {formatDate(formData.surveyDate)}
          </div>

          <div className="signature-section flex justify-between mt-8">
            <div className="signature-box text-left">
              <div className="font-bold">ग्रामसेवक स्वाक्षरी</div>
            </div>
            <div className="signature-box text-center">
              <div className="font-bold">सर्वेक्षण करणाऱ्या अधिकाऱ्याची स्वाक्षरी</div>
            </div>
            <div className="signature-box text-right">
              <div className="font-bold">कुटुंब प्रमुखाची स्वाक्षरी व अंगठा</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KutumbForm;